import { render, staticRenderFns } from "./TheCampaignCardType.vue?vue&type=template&id=060d0d11&scoped=true"
import script from "./TheCampaignCardType.vue?vue&type=script&lang=js"
export * from "./TheCampaignCardType.vue?vue&type=script&lang=js"
import style0 from "./TheCampaignCardType.vue?vue&type=style&index=0&id=060d0d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d0d11",
  null
  
)

export default component.exports